import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import SortableTable from "../../../Componentes/Utils/SortableTable";
import { useModal } from "../../../contexts/ModalContext";
import useApi from "../../../hooks/useApi";
import ModalPreencherItem from "./ModalPreencherItem";

const PageContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-sizing: border-box;
    overflow: hidden;
`;

const TableFlexFill = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
    display: flex;
    flex-direction: column;

    & > div {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }
`;

const Content = ({ onProssmapLoaded }) => {
    const { id } = useParams();
    const api = useApi();
    const { openModal, isModalOpen } = useModal();

    const [loading, setLoading] = useState(true);
    const [itens, setItens] = useState([]);
    const [prossmap, setProssmap] = useState(null);
    const [itemSelecionado, setItemSelecionado] = useState(null);

    const fetchProssmap = useCallback(async () => {
        if (!id) return;

        setLoading(true);
        try {
            const { data } = await api.get(`/Painel/API/Prossmap/Get/index.php?id=${id}`);
            const payload = data?.data ?? data;
            const prossmapData = payload?.prossmap ?? null;
            setProssmap(prossmapData);
            setItens(Array.isArray(payload?.itens) ? payload.itens : []);
            if (onProssmapLoaded) onProssmapLoaded(prossmapData);
        } catch (error) {
            console.error("Erro ao buscar itens do PROSSMAP:", error);
            setProssmap(null);
            setItens([]);
        } finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        fetchProssmap();
    }, [fetchProssmap]);

    const handleAbrirItem = (row) => {
        setItemSelecionado(row);
        openModal("prossmapPreencherItem");
    };

    const columns = useMemo(
        () => [
            {
                id: "tipo",
                header: "TIPO",
                accessor: "tipo_nome",
                sortable: true,
                width: "160px",
            },
            {
                id: "item",
                header: "ITEM",
                accessor: "ordem_label",
                sortable: true,
                width: "80px",
                align: "center",
                sortValue: (row) =>
                    Number(row.ordem_tipo ?? 0) * 10000 + Number(row.ordem_item ?? 0),
            },
            {
                id: "descricao",
                header: "DESCRIÇÃO",
                accessor: "descricao",
                sortable: true,
            },
            {
                id: "resposta",
                header: "RESPOSTA",
                accessor: (row) => row.resposta || "-",
                sortable: true,
                width: "140px",
                align: "center",
            },
            {
                id: "pontos_ganhos",
                header: "PONTOS",
                accessor: (row) => (row.resposta ? row.pontos_ganhos : "-"),
                sortable: true,
                width: "90px",
                align: "center",
                sortValue: (row) => Number(row.pontos_ganhos ?? 0),
            },
        ],
        []
    );

    const emptyText = prossmap
        ? "Nenhum item encontrado para este PROSSMAP."
        : "PROSSMAP não encontrado.";

    return (
        <>
            <PageContent>
                <TableFlexFill>
                    <SortableTable
                        columns={columns}
                        data={itens}
                        isLoading={loading}
                        loadingText="Carregando itens..."
                        emptyText={emptyText}
                        initialSort={{ key: "item", direction: "asc" }}
                        getRowId={(row) => row.id}
                        onRowClick={handleAbrirItem}
                        rowCursor="pointer"
                    />
                </TableFlexFill>
            </PageContent>

            {isModalOpen("prossmapPreencherItem") && (
                <ModalPreencherItem
                    item={itemSelecionado}
                    onSaved={fetchProssmap}
                    key={itemSelecionado?.id ?? "item"}
                />
            )}
        </>
    );
};

export default Content;
